/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      enum: [
        'WAREHOUSES_ARE_SEPARATE_BUILDINGS',
        'WAREHOUSES_ARE_WIN_PRODUCTION_BUILDINGS',
        'WAREHOUSES_ARE_SEPARATE_BUILDINGS_AND_WIN_PRODUCTION_BUILDINGS',
      ],
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    are_warehouses_win_or_separate_from_production_buildings: valueSchema,
  },
}
